module.exports = __webpack_public_path__ + "images/emoji/notes.7b2ad646b80c2c01c5df.png";